import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import MainLayout from '../layout/MainLayout';
import { apiService } from '../../services/api';
import { showToast } from '../common/Toaster';
import FodaBoard from '../plan/FodaBoard';
import PdiBuilder from '../plan/PdiBuilder';
import { Mail, Phone } from 'lucide-react';
import config from '../../config';
import './ficha.scss';

type Tab = 'foda' | 'informes' | 'pdi';

const MenteeDetailPage: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [loading, setLoading] = useState(true);
  const [mentee, setMentee] = useState<any>(null);
  const [rel, setRel] = useState<any>(null);
  const [stats, setStats] = useState<any>(null);
  const [tab, setTab] = useState<Tab>('foda');

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const res = await apiService.get(`/mentor/mentees/${id}`);
      const d = res.data?.data || res.data;
      setMentee(d?.mentee || null);
      setRel(d?.relationship || null);
      try { const s = await apiService.get(`/mentor/mentees/${id}/stats`); setStats(s.data?.data || s.data); } catch { /* opcional */ }
    } catch (e: any) {
      showToast(e?.response?.data?.message || 'No se pudo cargar el perfil', 'error');
    } finally { setLoading(false); }
  }, [id]);

  useEffect(() => { load(); }, [load]);

  if (loading) return <MainLayout><div className="ficha"><p className="ficha-loading">Cargando…</p></div></MainLayout>;
  if (!mentee) return <MainLayout><div className="ficha"><p className="ficha-loading">No se encontró el mentee.</p></div></MainLayout>;

  const name = `${mentee.first_name || ''} ${mentee.last_name || ''}`.trim();
  const initials = ((mentee.first_name?.[0] || '') + (mentee.last_name?.[0] || '')).toUpperCase() || 'M';
  const relId = Number(rel?.id);
  const imgUrl = mentee.profile_image
    ? (String(mentee.profile_image).startsWith('http') ? mentee.profile_image : `${config.api.baseUrl.replace(/\/api\/?$/, '')}/${mentee.profile_image}`)
    : null;

  return (
    <MainLayout>
      <div className="ficha">
        <div className="ficha-kicker">Ficha del mentee</div>
        <div className="ficha-rule" />

        <div className="ficha-profile-bar">
          <div className="ficha-avatar">{imgUrl ? <img src={imgUrl} alt={name} /> : initials}</div>
          <div className="ficha-profile-info">
            <div className="ficha-role">{name}</div>
            {mentee.email && <a className="ficha-sub ficha-sub--link" href={`mailto:${mentee.email}`}><Mail size={13} /> {mentee.email}</a>}
            {mentee.phone && <a className="ficha-sub ficha-sub--link" href={`tel:${mentee.phone}`}><Phone size={13} /> {mentee.phone}</a>}
          </div>
        </div>

        <div className="ficha-tabs">
          <button className={`ficha-tab ${tab === 'foda' ? 'active' : ''}`} onClick={() => setTab('foda')}>FODA Ejecutivo</button>
          <button className={`ficha-tab ${tab === 'pdi' ? 'active' : ''}`} onClick={() => setTab('pdi')}>PDI</button>
        </div>

        <div className="ficha-tabpanel">
          {!relId ? (
            <p className="ficha-loading">Sin relación activa.</p>
          ) : tab === 'foda' ? (
            <FodaBoard relId={relId} role="mentor" counterpart={name} onChanged={() => {}} />
          ) : tab === 'pdi' ? (
            <PdiBuilder relId={relId} role="mentor" counterpart={name} onChanged={() => {}} />
          ) : (
            <div className="ficha-informe">
              <div className="ficha-informe-grid">
                <div className="ficha-stat"><div className="ficha-stat-n">{stats?.total_sessions ?? 12}</div><div className="ficha-stat-l">Sesiones del programa</div></div>
                <div className="ficha-stat"><div className="ficha-stat-n">{stats?.completed_sessions ?? 0}</div><div className="ficha-stat-l">Sesiones efectivas</div></div>
                <div className="ficha-stat"><div className="ficha-stat-n">{stats?.total_goals ?? 0}</div><div className="ficha-stat-l">Objetivos del PDI</div></div>
                <div className="ficha-stat"><div className="ficha-stat-n">{stats?.progress_percentage != null ? `${Math.round(stats.progress_percentage)}%` : '—'}</div><div className="ficha-stat-l">Avance</div></div>
              </div>
              <p className="ficha-informe-note">El detalle del avance vive en las pestañas FODA y PDI. Las métricas se actualizan a medida que se registran las sesiones.</p>
            </div>
          )}
        </div>
      </div>
    </MainLayout>
  );
};

export default MenteeDetailPage;
